import { getHistoryCard } from "../../Reducers/historyCard/getHistoryCard"
import { useReducer } from "react"
import { globalInitialState } from "../initialStateGlobal"

export const useHistoryCardState = () =>{
  const [state, dispatch] = useReducer(getHistoryCard, globalInitialState);
  return {state, dispatch};
}
